export class BuildingInput {
    address: string = '';
    postalCode: string | null = null;
    city: string = '';
    country: string = '';
    name: string = '';
    [key: string]: any;
}